import { Plug, MousePointerClick, Zap } from "lucide-react";
import { Chapter } from "./Chapter";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    num: "01",
    icon: Plug,
    title: "Connect",
    desc: "Connect your existing business tools and information.",
  },
  {
    num: "02",
    icon: MousePointerClick,
    title: "Choose",
    desc: "Choose which parts of the business Nova should help manage.",
  },
  {
    num: "03",
    icon: Zap,
    title: "Automate",
    desc: "Nova coordinates workflows, handles repetitive work and keeps people informed.",
  },
];

export const HowItWorks = () => (
  <section id="how-to-setup" data-testid="how-it-works-section" className="scroll-mt-36 bg-white">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24 lg:py-32">
      <Chapter number="03" label="The Flow" title="How Nova Works">
        <div className="relative mt-16">
          <div
            className="hidden lg:block absolute top-[52px] left-[12%] right-[12%] h-px bg-gradient-to-r from-nova-blue/10 via-nova-blue/40 to-nova-blue/10"
            aria-hidden="true"
          />
          <div className="grid lg:grid-cols-3 gap-12 lg:gap-8">
            {STEPS.map((s, i) => (
              <Reveal key={s.num} delay={0.12 * i}>
                <div
                  data-testid={`how-step-${s.title.toLowerCase()}`}
                  className="group relative text-center lg:text-left"
                >
                  <div className="relative inline-flex">
                    <span className="relative z-10 w-[104px] h-[104px] rounded-3xl bg-white border border-slate-200 shadow-soft flex items-center justify-center group-hover:border-nova-blue/30 group-hover:shadow-lift transition-[box-shadow,border-color] duration-500">
                      <s.icon size={30} strokeWidth={1.4} className="text-nova-blue" />
                    </span>
                    <span className="absolute -top-3 -right-3 z-20 w-9 h-9 rounded-full bg-nova-navy text-white text-[11px] font-bold flex items-center justify-center tracking-wider">
                      {s.num}
                    </span>
                  </div>
                  <h3 className="mt-7 text-2xl font-bold tracking-tight text-nova-navy">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm lg:text-base text-nova-slate leading-relaxed max-w-xs mx-auto lg:mx-0">
                    {s.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </Chapter>
    </div>
  </section>
);
